export default __webpack_public_path__ + "static/media/greekgo-screenshot-01.f15d727b.png";